import Swal from "sweetalert2";

import { api } from "../../Api/api";
import { getToken } from "../login";
import { CREATE_BG_ACTIVITY_SUCCESS, DELETE_BG_ACTIVITY_FAIL, DELETE_BG_ACTIVITY_REQUEST, DELETE_BG_ACTIVITY_SUCCESS, FETCH_BG_ACTIVITY_FAIL, FETCH_BG_ACTIVITY_REQUEST, FETCH_BG_ACTIVITY_SUCCESS, SHOW_BG_ACTIVITY_FAIL, SHOW_BG_ACTIVITY_REQUEST, SHOW_BG_ACTIVITY_SUCCESS } from "../../ActionType/ActivityType/bgActivityType";
import { UPDATE_ABOUT_FAIL, UPDATE_ABOUT_SUCCESS } from "../../ActionType/AboutType/about";

export const createBgActivityAction =
  ( image) => (dispatch) => {
    const formData = new FormData();
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };
    
    formData.append("bg_image", image);

    api
      .post("bgActivity/create", formData, config)
      .then((response) => {
        const { status, data } = response;
        if (status == 200) {
          dispatch({
            type: CREATE_BG_ACTIVITY_SUCCESS,
            payload: data,
          });
          Swal.fire({
            icon: "success",
            timer: 2000,

            title: "Goode Job",
            text: "Information was Saved Successfuly",
          });
        }
      })
      .catch((erro) => {
        console.log(erro);
        Swal.fire({
          icon: "error",
          timer: 2000,

          title: "Opps ...",
          text: "Check Your Request",
        });
      });
  };

export const getBgActivityAction = () => (dispatch) => {
  const config = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
    
  };

  dispatch({
    type: FETCH_BG_ACTIVITY_REQUEST,
  });

  api
    .get("bgActivity", config)
    .then((response) => {
      // console.log(response)
      const { status, data } = response;
      if (status == 200) {
        dispatch({
          type: FETCH_BG_ACTIVITY_SUCCESS,
          payload: data,
        //   total:data.total,
        });
      }
    })
    .catch((erro) => {
      dispatch({
        type: FETCH_BG_ACTIVITY_FAIL,
        // payload:data,
      });
      Swal.fire({
        icon: "error",
        timer: 2000,

        title: "Opps ...",
        text: "Check Your Request",
      });
    });
};

export const deleteBgActivityAction = (id) => (dispatch) => {
  const config = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  };

  dispatch({
    type: DELETE_BG_ACTIVITY_REQUEST,
  });

  api
    .delete("bgActivity/delete/" + id, config)
    .then((response) => {
      const { status, data } = response;
      if (status == 200) {
        
        dispatch({
          type: DELETE_BG_ACTIVITY_SUCCESS,
          payload: data.data,
          
        });
        Swal.fire({
          icon: "success",
          timer: 2000,

          title: "Goode Job",
          text: "Information was Delete Successfuly",
        });
      }
    })
    .catch((erro) => {
      dispatch({
        type: DELETE_BG_ACTIVITY_FAIL,
        // payload:data,
      });
      Swal.fire({
        icon: "error",
        timer: 2000,

        title: "Opps ...",
        text: "Check Your Request",
      });
    });
};

export const showBgActivityAction = (id) => (dispatch) => {
  const config = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  };

  dispatch({
    type: SHOW_BG_ACTIVITY_REQUEST,
  });

  api
    .get("bgActivity/show/" + id, config)
    .then((response) => {
      // console.log(response)
      const { status, data } = response;
      if (status == 200) {
        console.log(data);
        dispatch({
          type: SHOW_BG_ACTIVITY_SUCCESS,
          payload: data,
        });
      }
    })
    .catch((erro) => {
      dispatch({
        type: SHOW_BG_ACTIVITY_FAIL,
        // payload:data,
      });
      Swal.fire({
        icon: "error",
        timer: 2000,

        title: "Opps ...",
        text: "Check Your Request",
      });
    });
};

export const updateBgActivityAction =  (id, image) => (dispatch) => {
    const formData = new FormData();
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };
    
    formData.append("bg_image", image);
    

  api
    .post(`bgActivity/update/${id}` ,formData, config)
    .then((response) => {
      
      const { status, data } = response;
      if (status == 200) {
        // console.log(data);
        dispatch({
          type: UPDATE_ABOUT_SUCCESS,
          payload: data,
        });

        Swal.fire({
            icon: "success",
            timer: 2000,

            title: "Goode Job",
            text: "Information was Update Successfuly",
          });
      }
    })
    .catch((erro) => {
      dispatch({
        type: UPDATE_ABOUT_FAIL,
        // payload:data,
      });
      Swal.fire({
        icon: "error",
        timer: 2000,

        title: "Opps ...",
        text: "Check Your Request",
      });
    });
};
